import React from "react"
import { graphql } from "gatsby"
import parse from "html-react-parser"

import * as s from "./Post.module.scss"

import Layout from "@components/main/layout/Layout"
import AllLayouts from "@components/main/AllLayouts"
import { BlogHeader } from "@components/main/blog-header/BlogHeader"
import { BlogPostCard } from "@components/main/blog-post-card/BlogPostCard"
import { AnimateWrapper } from "@components/main/animate-wrapper/AnimateWrapper"
import { SEO as GlobalSEO } from "@components/common/seo/SEO"
import { Schema } from "../../components/common/schema/Schema"

const Page = ({ pageContext, data }) => {
  const { wpPost } = data
  const { title, date, featuredImage, acfPost, categories } = wpPost
  const {
    page: { acfSeo, flexibleContent, slug },
  } = pageContext

  const { seoTags, seoTitle, ogImage } = acfSeo

  const posts = data.morePosts.nodes || []
  const layouts = flexibleContent.content || []


  // this is for testing remove before going live 
  
  const schemaObject = {
    "@context": "https://schema.org",
    "@type": "NewsArticle",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": `https://www.tennents.com/${pageContext.locale}/news/${wpPost.categories.nodes[0].slug}/${slug}`
    },
    "headline": `${title}`,
    "description": `${acfSeo?.seoTags?.[0]?.content}`,
    "image": `${wpPost.featuredImage.node.sourceUrl}`,  
    "author": {
      "@type": "Organization",
      "name": "Tennent's Lager",
      "url": `https://www.tennents.com/${pageContext.locale}/news`
    },  
    "publisher": {
      "@type": "Organization",
      "name": "Tennent's",
      "logo": {
        "@type": "ImageObject",
        "url": "https://candcgroupplc.com/wp-content/uploads/2023/10/tennents_logo_careers.jpg"
      }
    },
    "datePublished": `${wpPost.date}`,
    "dateModified": `${wpPost.date}`
  };
  
  console.log("Post Data : ", schemaObject);

  // ---------------------------
  

  return (
    <Layout ageGateImage={null} pageData={pageContext} template={"null"}>
      <GlobalSEO
        data={{
          tags: seoTags,
          title: seoTitle,
          image: ogImage,
        }}
      />

      <Schema data={{
        "@context": "https://schema.org",
        "@type": "NewsArticle",
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": `https://www.tennents.com/${pageContext.locale}/news/${wpPost.categories.nodes[0].slug}/${slug}`
        },
        "headline": `${title}`,
        "description": `${acfSeo?.seoTags?.[0]?.content}`,
        "image": `${wpPost.featuredImage.node.sourceUrl}`,  
        "author": {
          "@type": "Organization",
          "name": "Tennent's Lager",
          "url": `https://www.tennents.com/${pageContext.locale}/news`
        },  
        "publisher": {
          "@type": "Organization",
          "name": "Tennent's",
          "logo": {
            "@type": "ImageObject",
            "url": "https://candcgroupplc.com/wp-content/uploads/2023/10/tennents_logo_careers.jpg"
          }
        },
        "datePublished": `${wpPost.date}`,
        "dateModified": `${wpPost.date}`
      }} />

      <BlogHeader
        title={parse(title)}
        category={categories.nodes[0].name}
        date={date}
        image={featuredImage && featuredImage.node.sourceUrl}
        mainColor={acfPost.mainColor}
      />

      <div className={s.Post}>
        <AnimateWrapper>
          {layouts.map((layout, index) => {
            return <AllLayouts key={index} layoutData={layout} />
          })}{" "}
        </AnimateWrapper>

        <div className={s.PostsContainer}>
          <div className={s.PostsContainer__slider}>
            {posts.map((post, i) => {
              return <BlogPostCard post={post} key={i} />
            })}
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default Page

export const query = graphql`
  query PostQuery($slug: String) {
    wpPost(slug: { eq: $slug }) {
      title
      acfPost {
        mainColor
      }
      featuredImage {
        node {
          sourceUrl
        }
      }
      categories {
        nodes {
          slug
          uri
          name
        }
      }
      date(formatString: "MMM DD, YYYY")
    }

    morePosts: allWpPost(
      limit: 3
      filter: {
        status: { eq: "publish" }
        title: { ne: "dummy" }
        slug: { ne: $slug }
      }
    ) {
      nodes {
        title
        slug
        featuredImage {
          node {
            sourceUrl
            altText
            localFile {
              childImageSharp {
                gatsbyImageData(
                  placeholder: BLURRED
                  quality: 80
                  formats: [WEBP]
                )
              }
            }
          }
        }
        categories {
          nodes {
            slug
            name
          }
        }
        date(formatString: "MMM DD, YYYY")
        acfPost {
          excerpt
        }
      }
    }
  }
`
